package dev.terrakok.mapitan.ui

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

object Icons {

    val Minus: ImageVector by lazy {
        ImageVector.Builder("Minus", 24.dp, 24.dp, 24f, 24f).apply {
            path(
                fill = null, stroke = SolidColor(Color.Black), strokeLineWidth = 2f,
                strokeLineCap = StrokeCap.Round,
                pathFillType = PathFillType.NonZero
            ) {
                moveTo(5f, 12f); lineTo(19f, 12f)
            }
        }.build()
    }

    val Plus: ImageVector by lazy {
        ImageVector.Builder("Plus", 24.dp, 24.dp, 24f, 24f).apply {
            path(
                fill = null, stroke = SolidColor(Color.Black), strokeLineWidth = 2f,
                strokeLineCap = StrokeCap.Round,
                pathFillType = PathFillType.NonZero
            ) {
                moveTo(12f, 5f); lineTo(12f, 19f)
            }
            path(
                fill = null, stroke = SolidColor(Color.Black), strokeLineWidth = 2f,
                strokeLineCap = StrokeCap.Round,
                pathFillType = PathFillType.NonZero
            ) {
                moveTo(5f, 12f); lineTo(19f, 12f)
            }
        }.build()
    }

    val Undo: ImageVector by lazy {
        ImageVector.Builder(
            name = "arrow-hook-up-left",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(7f, 19.25f)
                curveTo(7f, 19.6642f, 7.33579f, 20f, 7.75f, 20f)
                horizontalLineTo(14f)
                curveTo(15.9786f, 20f, 17.5041f, 19.1773f, 18.5198f, 17.9258f)
                curveTo(19.5207f, 16.6926f, 20f, 15.0799f, 20f, 13.5f)
                curveTo(20f, 11.9201f, 19.5207f, 10.3074f, 18.5198f, 9.07425f)
                curveTo(17.5041f, 7.82266f, 15.9786f, 7f, 14f, 7f)
                horizontalLineTo(7.56066f)
                lineTo(10.0303f, 4.53033f)
                curveTo(10.3232f, 4.23744f, 10.3232f, 3.76256f, 10.0303f, 3.46967f)
                curveTo(9.73744f, 3.17678f, 9.26256f, 3.17678f, 8.96967f, 3.46967f)
                lineTo(5.21967f, 7.21967f)
                curveTo(4.92678f, 7.51256f, 4.92678f, 7.98744f, 5.21967f, 8.28033f)
                lineTo(8.96967f, 12.0303f)
                curveTo(9.26256f, 12.3232f, 9.73744f, 12.3232f, 10.0303f, 12.0303f)
                curveTo(10.3232f, 11.7374f, 10.3232f, 11.2626f, 10.0303f, 10.9697f)
                lineTo(7.56066f, 8.5f)
                horizontalLineTo(14f)
                curveTo(15.5214f, 8.5f, 16.6209f, 9.11484f, 17.3552f, 10.0195f)
                curveTo(18.1043f, 10.9426f, 18.5f, 12.2049f, 18.5f, 13.5f)
                curveTo(18.5f, 14.7951f, 18.1043f, 16.0574f, 17.3552f, 16.9805f)
                curveTo(16.6209f, 17.8852f, 15.5214f, 18.5f, 14f, 18.5f)
                horizontalLineTo(7.75f)
                curveTo(7.33579f, 18.5f, 7f, 18.8358f, 7f, 19.25f)
                close()
            }
        }.build()
    }

    val Redo: ImageVector by lazy {
        ImageVector.Builder(
            name = "arrow-hook-up-right",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(10.5f, 18.5f)
                horizontalLineTo(16.25f)
                curveTo(16.6642f, 18.5f, 17f, 18.8358f, 17f, 19.25f)
                curveTo(17f, 19.6642f, 16.6642f, 20f, 16.25f, 20f)
                horizontalLineTo(10.5f)
                curveTo(6.91015f, 20f, 4f, 17.0899f, 4f, 13.5f)
                curveTo(4f, 9.91015f, 6.91015f, 7f, 10.5f, 7f)
                horizontalLineTo(16.4503f)
                lineTo(13.8336f, 4.38323f)
                curveTo(13.5407f, 4.09033f, 13.5407f, 3.61546f, 13.8336f, 3.32257f)
                curveTo(14.1264f, 3.02967f, 14.6013f, 3.02967f, 14.8942f, 3.32257f)
                lineTo(18.7765f, 7.2049f)
                curveTo(18.8762f, 7.30454f, 18.9419f, 7.42524f, 18.9738f, 7.55267f)
                curveTo(18.9909f, 7.61554f, 19f, 7.68171f, 19f, 7.75f)
                curveTo(19f, 7.96292f, 18.9113f, 8.15511f, 18.7688f, 8.29163f)
                lineTo(14.8887f, 12.1717f)
                curveTo(14.5958f, 12.4646f, 14.121f, 12.4646f, 13.8281f, 12.1717f)
                curveTo(13.5352f, 11.8788f, 13.5352f, 11.4039f, 13.8281f, 11.111f)
                lineTo(16.4391f, 8.5f)
                horizontalLineTo(10.5f)
                curveTo(7.73858f, 8.5f, 5.5f, 10.7386f, 5.5f, 13.5f)
                curveTo(5.5f, 16.2614f, 7.73858f, 18.5f, 10.5f, 18.5f)
                close()
            }
        }.build()
    }

    val Track: ImageVector by lazy {
        ImageVector.Builder(
            name = "data-line",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(16f, 6f)
                curveTo(16f, 4.34315f, 17.3431f, 3f, 19f, 3f)
                curveTo(20.6569f, 3f, 22f, 4.34315f, 22f, 6f)
                curveTo(22f, 7.65685f, 20.6569f, 9f, 19f, 9f)
                curveTo(18.838f, 9f, 18.679f, 8.98716f, 18.524f, 8.96245f)
                lineTo(16.4862f, 12.3205f)
                curveTo(16.8105f, 12.7997f, 17f, 13.3777f, 17f, 14f)
                curveTo(17f, 15.6569f, 15.6569f, 17f, 14f, 17f)
                curveTo(13.0972f, 17f, 12.2875f, 16.6012f, 11.7375f, 15.9701f)
                lineTo(7.99584f, 17.8407f)
                curveTo(7.9986f, 17.8934f, 8f, 17.9466f, 8f, 18f)
                curveTo(8f, 19.6569f, 6.65685f, 21f, 5f, 21f)
                curveTo(3.34315f, 21f, 2f, 19.6569f, 2f, 18f)
                curveTo(2f, 16.3431f, 3.34315f, 15f, 5f, 15f)
                curveTo(6.0662f, 15f, 7.00249f, 15.5562f, 7.53455f, 16.3943f)
                lineTo(11.066f, 14.6288f)
                curveTo(11.0228f, 14.4261f, 11f, 14.2157f, 11f, 14f)
                curveTo(11f, 12.3431f, 12.3431f, 11f, 14f, 11f)
                curveTo(14.4821f, 11f, 14.9376f, 11.1137f, 15.3413f, 11.3158f)
                lineTo(17.1391f, 8.35326f)
                curveTo(16.4452f, 7.80378f, 16f, 6.95388f, 16f, 6f)
                close()
            }
        }.build()
    }

    val MapPin: ImageVector by lazy {
        ImageVector.Builder(
            name = "location_pin",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Transparent)
            ) {
                moveTo(0f, 0f)
                horizontalLineTo(24f)
                verticalLineTo(24f)
                horizontalLineTo(0f)
                verticalLineTo(0f)
                close()
            }
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(12f, 2f)
                lineTo(12f, 2f)
                curveTo(8.13f, 2f, 5f, 5.13f, 5f, 9f)
                curveToRelative(0f, 1.74f, 0.5f, 3.37f, 1.41f, 4.84f)
                curveToRelative(0.95f, 1.54f, 2.2f, 2.86f, 3.16f, 4.4f)
                curveToRelative(0.47f, 0.75f, 0.81f, 1.45f, 1.17f, 2.26f)
                curveTo(11f, 21.05f, 11.21f, 22f, 12f, 22f)
                horizontalLineToRelative(0f)
                curveToRelative(0.79f, 0f, 1f, -0.95f, 1.25f, -1.5f)
                curveToRelative(0.37f, -0.81f, 0.7f, -1.51f, 1.17f, -2.26f)
                curveToRelative(0.96f, -1.53f, 2.21f, -2.85f, 3.16f, -4.4f)
                curveTo(18.5f, 12.37f, 19f, 10.74f, 19f, 9f)
                curveTo(19f, 5.13f, 15.87f, 2f, 12f, 2f)
                close()
                moveTo(12f, 11.75f)
                curveToRelative(-1.38f, 0f, -2.5f, -1.12f, -2.5f, -2.5f)
                reflectiveCurveToRelative(1.12f, -2.5f, 2.5f, -2.5f)
                reflectiveCurveToRelative(2.5f, 1.12f, 2.5f, 2.5f)
                reflectiveCurveTo(13.38f, 11.75f, 12f, 11.75f)
                close()
            }
        }.build()
    }
    val Pin: ImageVector by lazy {
        ImageVector.Builder(
            name = "location",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(5.84324f, 4.56908f)
                curveTo(9.24363f, 1.16873f, 14.7563f, 1.1687f, 18.1566f, 4.56908f)
                curveTo(21.5568f, 7.96947f, 21.5569f, 13.4822f, 18.1566f, 16.8825f)
                lineTo(16.9701f, 18.0563f)
                curveTo(16.0953f, 18.915f, 14.9596f, 20.0193f, 13.5639f, 21.3688f)
                curveTo(12.6918f, 22.2118f, 11.308f, 22.2118f, 10.436f, 21.3688f)
                lineTo(6.94479f, 17.9723f)
                curveTo(6.50618f, 17.5416f, 6.13901f, 17.1783f, 5.84324f, 16.8825f)
                curveTo(2.44289f, 13.4821f, 2.44299f, 7.96948f, 5.84324f, 4.56908f)
                close()
                moveTo(11.9994f, 8.0007f)
                curveTo(10.3426f, 8.00073f, 8.99946f, 9.34385f, 8.99946f, 11.0007f)
                curveTo(8.99962f, 12.6574f, 10.3427f, 14.0006f, 11.9994f, 14.0007f)
                curveTo(13.6562f, 14.0007f, 14.9993f, 12.6574f, 14.9994f, 11.0007f)
                curveTo(14.9994f, 9.34383f, 13.6563f, 8.0007f, 11.9994f, 8.0007f)
                close()
            }
        }.build()
    }

    val Area: ImageVector by lazy {
        ImageVector.Builder(
            name = "select-object-skew",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(18.5858f, 6.41421f)
                curveTo(18.9477f, 6.77614f, 19.4477f, 7f, 20f, 7f)
                curveTo(20.1675f, 7f, 20.3301f, 6.97942f, 20.4856f, 6.94064f)
                curveTo(21.3555f, 6.72367f, 22f, 5.9371f, 22f, 5f)
                curveTo(22f, 3.89543f, 21.1046f, 3f, 20f, 3f)
                curveTo(19.2406f, 3f, 18.5801f, 3.42323f, 18.2414f, 4.04668f)
                curveTo(18.0874f, 4.33007f, 18f, 4.65482f, 18f, 5f)
                curveTo(18f, 5.36428f, 18.0974f, 5.70583f, 18.2676f, 6f)
                curveTo(18.3498f, 6.14225f, 18.4491f, 6.27341f, 18.5627f, 6.39073f)
                curveTo(18.5703f, 6.39862f, 18.578f, 6.40645f, 18.5858f, 6.41421f)
                close()
                moveTo(14.2676f, 20f)
                curveTo(14.6134f, 20.5978f, 15.2597f, 21f, 16f, 21f)
                curveTo(17.1046f, 21f, 18f, 20.1046f, 18f, 19f)
                curveTo(18f, 18.4596f, 17.7857f, 17.9693f, 17.4374f, 17.6093f)
                curveTo(17.4297f, 17.6014f, 17.422f, 17.5936f, 17.4142f, 17.5858f)
                curveTo(17.0523f, 17.2239f, 16.5523f, 17f, 16f, 17f)
                curveTo(15.8326f, 17f, 15.6699f, 17.0206f, 15.5145f, 17.0593f)
                curveTo(14.965f, 17.1964f, 14.5054f, 17.5607f, 14.2414f, 18.0467f)
                curveTo(14.0874f, 18.3301f, 14f, 18.6548f, 14f, 19f)
                curveTo(14f, 19.3643f, 14.0974f, 19.7058f, 14.2676f, 20f)
                close()
                moveTo(4f, 21f)
                curveTo(2.89543f, 21f, 2f, 20.1046f, 2f, 19f)
                curveTo(2f, 18.0629f, 2.64454f, 17.2763f, 3.51451f, 17.0593f)
                curveTo(3.52574f, 17.0565f, 3.53702f, 17.0538f, 3.54833f, 17.0512f)
                curveTo(3.69348f, 17.0177f, 3.84467f, 17f, 4f, 17f)
                curveTo(4.56417f, 17f, 5.07378f, 17.2336f, 5.43739f, 17.6093f)
                curveTo(5.56321f, 17.7394f, 5.67155f, 17.8864f, 5.75861f, 18.0467f)
                curveTo(5.91256f, 18.3301f, 6f, 18.6548f, 6f, 19f)
                curveTo(6f, 19.3643f, 5.9026f, 19.7058f, 5.73244f, 20f)
                curveTo(5.38663f, 20.5978f, 4.74029f, 21f, 4f, 21f)
                close()
                moveTo(6.58579f, 6.41421f)
                curveTo(6.94772f, 6.77614f, 7.44772f, 7f, 8f, 7f)
                curveTo(8.16747f, 7f, 8.33013f, 6.97942f, 8.48559f, 6.94064f)
                curveTo(9.01734f, 6.80802f, 9.46486f, 6.46256f, 9.73244f, 6f)
                curveTo(9.74136f, 5.98457f, 9.75009f, 5.96901f, 9.75861f, 5.95332f)
                curveTo(9.91256f, 5.66993f, 10f, 5.34518f, 10f, 5f)
                curveTo(10f, 4.63571f, 9.90261f, 4.29417f, 9.73244f, 4f)
                curveTo(9.38663f, 3.4022f, 8.74028f, 3f, 8f, 3f)
                curveTo(6.89543f, 3f, 6f, 3.89543f, 6f, 5f)
                curveTo(6f, 5.54043f, 6.21435f, 6.0308f, 6.56268f, 6.39073f)
                curveTo(6.57032f, 6.39862f, 6.57802f, 6.40645f, 6.58579f, 6.41421f)
                close()
                moveTo(3.81558f, 16.0056f)
                lineTo(6.26142f, 7.44515f)
                curveTo(6.75188f, 7.79452f, 7.35195f, 8f, 8f, 8f)
                curveTo(8.06196f, 8f, 8.12348f, 7.99812f, 8.18451f, 7.99442f)
                lineTo(5.73866f, 16.5549f)
                curveTo(5.24818f, 16.2055f, 4.64809f, 16f, 4f, 16f)
                curveTo(3.93807f, 16f, 3.87658f, 16.0019f, 3.81558f, 16.0056f)
                close()
                moveTo(17.1707f, 6f)
                horizontalLineTo(10.8293f)
                curveTo(10.9398f, 5.68722f, 11f, 5.35064f, 11f, 5f)
                curveTo(11f, 4.64936f, 10.9398f, 4.31278f, 10.8293f, 4f)
                horizontalLineTo(17.1707f)
                curveTo(17.0602f, 4.31278f, 17f, 4.64936f, 17f, 5f)
                curveTo(17f, 5.35064f, 17.0602f, 5.68722f, 17.1707f, 6f)
                close()
                moveTo(13.1707f, 20f)
                curveTo(13.0602f, 19.6872f, 13f, 19.3506f, 13f, 19f)
                curveTo(13f, 18.6494f, 13.0602f, 18.3128f, 13.1707f, 18f)
                horizontalLineTo(6.82929f)
                curveTo(6.93985f, 18.3128f, 7f, 18.6494f, 7f, 19f)
                curveTo(7f, 19.3506f, 6.93985f, 19.6872f, 6.82929f, 20f)
                horizontalLineTo(13.1707f)
                close()
                moveTo(15.8156f, 16.0056f)
                lineTo(18.2614f, 7.44515f)
                curveTo(18.7519f, 7.79452f, 19.3519f, 8f, 20f, 8f)
                curveTo(20.062f, 8f, 20.1235f, 7.99812f, 20.1845f, 7.99442f)
                lineTo(17.7387f, 16.5549f)
                curveTo(17.2482f, 16.2055f, 16.6481f, 16f, 16f, 16f)
                curveTo(15.9381f, 16f, 15.8766f, 16.0019f, 15.8156f, 16.0056f)
                close()
            }
        }.build()
    }

    val Cursor: ImageVector by lazy {
        ImageVector.Builder(
            name = "cursor",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(7.92098f, 2.29927f)
                curveTo(6.93571f, 1.53286f, 5.5f, 2.23498f, 5.5f, 3.48325f)
                verticalLineTo(20.492f)
                curveTo(5.5f, 21.9142f, 7.2945f, 22.538f, 8.17661f, 21.4224f)
                lineTo(12.3676f, 16.1222f)
                curveTo(12.6806f, 15.7264f, 13.1574f, 15.4956f, 13.6619f, 15.4956f)
                horizontalLineTo(20.5143f)
                curveTo(21.9425f, 15.4956f, 22.5626f, 13.6885f, 21.4353f, 12.8116f)
                lineTo(7.92098f, 2.29927f)
                close()
            }
        }.build()
    }

    val Pen: ImageVector by lazy {
        ImageVector.Builder(
            name = "edit",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(20.9519f, 3.0481f)
                curveTo(19.5543f, 1.65058f, 17.2885f, 1.65064f, 15.8911f, 3.04825f)
                lineTo(3.94103f, 14.9997f)
                curveTo(3.5347f, 15.4061f, 3.2491f, 15.9172f, 3.116f, 16.4762f)
                lineTo(2.02041f, 21.0777f)
                curveTo(1.96009f, 21.3311f, 2.03552f, 21.5976f, 2.21968f, 21.7817f)
                curveTo(2.40385f, 21.9659f, 2.67037f, 22.0413f, 2.92373f, 21.981f)
                lineTo(7.52498f, 20.8855f)
                curveTo(8.08418f, 20.7523f, 8.59546f, 20.4666f, 9.00191f, 20.0601f)
                lineTo(20.952f, 8.10861f)
                curveTo(22.3493f, 6.71112f, 22.3493f, 4.4455f, 20.9519f, 3.0481f)
                close()
                moveTo(16.9518f, 4.10884f)
                curveTo(17.7634f, 3.29709f, 19.0795f, 3.29705f, 19.8912f, 4.10876f)
                curveTo(20.7028f, 4.9204f, 20.7029f, 6.23632f, 19.8913f, 7.04801f)
                lineTo(19f, 7.93946f)
                lineTo(16.0606f, 5.00012f)
                lineTo(16.9518f, 4.10884f)
                close()
                moveTo(15f, 6.06084f)
                lineTo(17.9394f, 9.00018f)
                lineTo(7.94119f, 18.9995f)
                curveTo(7.73104f, 19.2097f, 7.46668f, 19.3574f, 7.17755f, 19.4263f)
                lineTo(3.76191f, 20.2395f)
                lineTo(4.57521f, 16.8237f)
                curveTo(4.64402f, 16.5346f, 4.79168f, 16.2704f, 5.00175f, 16.0603f)
                lineTo(15f, 6.06084f)
                close()
            }
        }.build()
    }

    val Delete: ImageVector by lazy {
        ImageVector.Builder(
            name = "delete",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(10f, 5f)
                horizontalLineTo(14f)
                curveTo(14f, 3.89543f, 13.1046f, 3f, 12f, 3f)
                curveTo(10.8954f, 3f, 10f, 3.89543f, 10f, 5f)
                close()
                moveTo(8.5f, 5f)
                curveTo(8.5f, 3.067f, 10.067f, 1.5f, 12f, 1.5f)
                curveTo(13.933f, 1.5f, 15.5f, 3.067f, 15.5f, 5f)
                horizontalLineTo(21.25f)
                curveTo(21.6642f, 5f, 22f, 5.33579f, 22f, 5.75f)
                curveTo(22f, 6.16421f, 21.6642f, 6.5f, 21.25f, 6.5f)
                horizontalLineTo(19.9309f)
                lineTo(18.7589f, 18.6112f)
                curveTo(18.5729f, 20.5334f, 16.9575f, 22f, 15.0263f, 22f)
                horizontalLineTo(8.97369f)
                curveTo(7.04254f, 22f, 5.42715f, 20.5334f, 5.24113f, 18.6112f)
                lineTo(4.06908f, 6.5f)
                horizontalLineTo(2.75f)
                curveTo(2.33579f, 6.5f, 2f, 6.16421f, 2f, 5.75f)
                curveTo(2f, 5.33579f, 2.33579f, 5f, 2.75f, 5f)
                horizontalLineTo(8.5f)
                close()
                moveTo(10.5f, 9.75f)
                curveTo(10.5f, 9.33579f, 10.1642f, 9f, 9.75f, 9f)
                curveTo(9.33579f, 9f, 9f, 9.33579f, 9f, 9.75f)
                verticalLineTo(17.25f)
                curveTo(9f, 17.6642f, 9.33579f, 18f, 9.75f, 18f)
                curveTo(10.1642f, 18f, 10.5f, 17.6642f, 10.5f, 17.25f)
                verticalLineTo(9.75f)
                close()
                moveTo(14.25f, 9f)
                curveTo(13.8358f, 9f, 13.5f, 9.33579f, 13.5f, 9.75f)
                verticalLineTo(17.25f)
                curveTo(13.5f, 17.6642f, 13.8358f, 18f, 14.25f, 18f)
                curveTo(14.6642f, 18f, 15f, 17.6642f, 15f, 17.25f)
                verticalLineTo(9.75f)
                curveTo(15f, 9.33579f, 14.6642f, 9f, 14.25f, 9f)
                close()
            }
        }.build()
    }

    val LockOpen: ImageVector by lazy {
        ImageVector.Builder(
            name = "lock-open",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(18.75f, 1f)
                curveTo(21.3734f, 1f, 23.5f, 3.12665f, 23.5f, 5.75f)
                verticalLineTo(6.25f)
                curveTo(23.5f, 6.66421f, 23.1642f, 7f, 22.75f, 7f)
                curveTo(22.3358f, 7f, 22f, 6.66421f, 22f, 6.25f)
                verticalLineTo(5.75f)
                curveTo(22f, 3.95507f, 20.5449f, 2.5f, 18.75f, 2.5f)
                curveTo(16.9551f, 2.5f, 15.5f, 3.95507f, 15.5f, 5.75f)
                verticalLineTo(8f)
                horizontalLineTo(16.75f)
                curveTo(18.5449f, 8f, 20f, 9.45507f, 20f, 11.25f)
                verticalLineTo(18.75f)
                curveTo(20f, 20.5449f, 18.5449f, 22f, 16.75f, 22f)
                horizontalLineTo(7.25f)
                curveTo(5.45507f, 22f, 4f, 20.5449f, 4f, 18.75f)
                verticalLineTo(11.25f)
                curveTo(4f, 9.45507f, 5.45507f, 8f, 7.25f, 8f)
                horizontalLineTo(14f)
                verticalLineTo(5.75f)
                curveTo(14f, 3.12665f, 16.1266f, 1f, 18.75f, 1f)
                close()
                moveTo(12f, 13.75f)
                curveTo(11.3096f, 13.75f, 10.75f, 14.3096f, 10.75f, 15f)
                curveTo(10.75f, 15.6904f, 11.3096f, 16.25f, 12f, 16.25f)
                curveTo(12.6904f, 16.25f, 13.25f, 15.6904f, 13.25f, 15f)
                curveTo(13.25f, 14.3096f, 12.6904f, 13.75f, 12f, 13.75f)
                close()
            }
        }.build()
    }

    val LockClosed: ImageVector by lazy {
        ImageVector.Builder(
            name = "lock-closed",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(12f, 1f)
                curveTo(14.7614f, 1f, 17f, 3.23858f, 17f, 6f)
                verticalLineTo(8.00977f)
                curveTo(18.6781f, 8.13743f, 20f, 9.5392f, 20f, 11.25f)
                verticalLineTo(18.75f)
                curveTo(20f, 20.5449f, 18.5449f, 22f, 16.75f, 22f)
                horizontalLineTo(7.25f)
                curveTo(5.45507f, 22f, 4f, 20.5449f, 4f, 18.75f)
                verticalLineTo(11.25f)
                curveTo(4f, 9.5392f, 5.3219f, 8.13743f, 7f, 8.00977f)
                verticalLineTo(6f)
                curveTo(7f, 3.23858f, 9.23858f, 1f, 12f, 1f)
                close()
                moveTo(12f, 13.75f)
                curveTo(11.3096f, 13.75f, 10.75f, 14.3096f, 10.75f, 15f)
                curveTo(10.75f, 15.6904f, 11.3096f, 16.25f, 12f, 16.25f)
                curveTo(12.6904f, 16.25f, 13.25f, 15.6904f, 13.25f, 15f)
                curveTo(13.25f, 14.3096f, 12.6904f, 13.75f, 12f, 13.75f)
                close()
                moveTo(12f, 2.5f)
                curveTo(10.067f, 2.5f, 8.5f, 4.067f, 8.5f, 6f)
                verticalLineTo(8f)
                horizontalLineTo(15.5f)
                verticalLineTo(6f)
                curveTo(15.5f, 4.067f, 13.933f, 2.5f, 12f, 2.5f)
                close()
            }
        }.build()
    }

    val Hamburger: ImageVector by lazy {
        ImageVector.Builder(
            name = "line-horizontal-3",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(3f, 17f)
                horizontalLineTo(21f)
                curveTo(21.5523f, 17f, 22f, 17.4477f, 22f, 18f)
                curveTo(22f, 18.5128f, 21.614f, 18.9355f, 21.1166f, 18.9933f)
                lineTo(21f, 19f)
                horizontalLineTo(3f)
                curveTo(2.44772f, 19f, 2f, 18.5523f, 2f, 18f)
                curveTo(2f, 17.4872f, 2.38604f, 17.0645f, 2.88338f, 17.0067f)
                lineTo(3f, 17f)
                horizontalLineTo(21f)
                horizontalLineTo(3f)
                close()
                moveTo(2.99988f, 11f)
                lineTo(20.9999f, 10.9978f)
                curveTo(21.5522f, 10.9978f, 22f, 11.4454f, 22f, 11.9977f)
                curveTo(22f, 12.5106f, 21.6141f, 12.9333f, 21.1167f, 12.9911f)
                lineTo(21.0001f, 12.9978f)
                lineTo(3.00012f, 13f)
                curveTo(2.44784f, 13.0001f, 2f, 12.5524f, 2f, 12.0001f)
                curveTo(2f, 11.4873f, 2.38594f, 11.0646f, 2.88326f, 11.0067f)
                lineTo(2.99988f, 11f)
                lineTo(20.9999f, 10.9978f)
                lineTo(2.99988f, 11f)
                close()
                moveTo(3f, 5f)
                horizontalLineTo(21f)
                curveTo(21.5523f, 5f, 22f, 5.44772f, 22f, 6f)
                curveTo(22f, 6.51284f, 21.614f, 6.93551f, 21.1166f, 6.99327f)
                lineTo(21f, 7f)
                horizontalLineTo(3f)
                curveTo(2.44772f, 7f, 2f, 6.55228f, 2f, 6f)
                curveTo(2f, 5.48716f, 2.38604f, 5.06449f, 2.88338f, 5.00673f)
                lineTo(3f, 5f)
                horizontalLineTo(21f)
                horizontalLineTo(3f)
                close()
            }
        }.build()
    }

    val Text: ImageVector by lazy {
        ImageVector.Builder(
            name = "text",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 16f,
            viewportHeight = 16f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(2.5f, 2.75f)
                curveTo(2.5f, 2.33579f, 2.83579f, 2f, 3.25f, 2f)
                horizontalLineTo(12.25f)
                curveTo(12.6642f, 2f, 13f, 2.33579f, 13f, 2.75f)
                verticalLineTo(4.25f)
                curveTo(13f, 4.66421f, 12.6642f, 5f, 12.25f, 5f)
                curveTo(11.8358f, 5f, 11.5f, 4.66421f, 11.5f, 4.25f)
                verticalLineTo(3.5f)
                horizontalLineTo(8.49998f)
                verticalLineTo(12.5f)
                horizontalLineTo(9.74998f)
                curveTo(10.1642f, 12.5f, 10.5f, 12.8358f, 10.5f, 13.25f)
                curveTo(10.5f, 13.6642f, 10.1642f, 14f, 9.74998f, 14f)
                horizontalLineTo(5.74998f)
                curveTo(5.33576f, 14f, 4.99998f, 13.6642f, 4.99998f, 13.25f)
                curveTo(4.99998f, 12.8358f, 5.33576f, 12.5f, 5.74998f, 12.5f)
                horizontalLineTo(6.99998f)
                verticalLineTo(3.5f)
                horizontalLineTo(4f)
                verticalLineTo(4.25f)
                curveTo(4f, 4.66421f, 3.66421f, 5f, 3.25f, 5f)
                curveTo(2.83579f, 5f, 2.5f, 4.66421f, 2.5f, 4.25f)
                verticalLineTo(2.75f)
                close()
            }
        }.build()
    }

    val Open: ImageVector by lazy {
        ImageVector.Builder(
            name = "open",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(6.24992f, 4.5f)
                curveTo(5.28344f, 4.5f, 4.49996f, 5.2835f, 4.49996f, 6.25f)
                verticalLineTo(17.75f)
                curveTo(4.49996f, 18.7165f, 5.28344f, 19.5f, 6.24992f, 19.5f)
                horizontalLineTo(17.7496f)
                curveTo(18.7161f, 19.5f, 19.4996f, 18.7165f, 19.4996f, 17.75f)
                verticalLineTo(13.75f)
                curveTo(19.4996f, 13.3358f, 19.8354f, 13f, 20.2496f, 13f)
                curveTo(20.6638f, 13f, 20.9995f, 13.3358f, 20.9995f, 13.75f)
                verticalLineTo(17.75f)
                curveTo(20.9995f, 19.5449f, 19.5445f, 21f, 17.7496f, 21f)
                horizontalLineTo(6.24992f)
                curveTo(4.45504f, 21f, 3f, 19.5449f, 3f, 17.75f)
                verticalLineTo(6.25f)
                curveTo(3f, 4.45507f, 4.45504f, 3f, 6.24992f, 3f)
                horizontalLineTo(10.2498f)
                curveTo(10.664f, 3f, 10.9998f, 3.33579f, 10.9998f, 3.75f)
                curveTo(10.9998f, 4.16421f, 10.664f, 4.5f, 10.2498f, 4.5f)
                horizontalLineTo(6.24992f)
                close()
                moveTo(12.9997f, 3.75f)
                curveTo(12.9997f, 3.33579f, 13.3355f, 3f, 13.7497f, 3f)
                horizontalLineTo(20.25f)
                curveTo(20.6642f, 3f, 21f, 3.33579f, 21f, 3.75f)
                verticalLineTo(10.25f)
                curveTo(21f, 10.6642f, 20.6642f, 11f, 20.25f, 11f)
                curveTo(19.8358f, 11f, 19.5f, 10.6642f, 19.5f, 10.25f)
                verticalLineTo(5.56074f)
                lineTo(14.28f, 10.7804f)
                curveTo(13.9871f, 11.0732f, 13.5123f, 11.0732f, 13.2194f, 10.7803f)
                curveTo(12.9265f, 10.4874f, 12.9265f, 10.0125f, 13.2194f, 9.71964f)
                lineTo(18.4395f, 4.5f)
                horizontalLineTo(13.7497f)
                curveTo(13.3355f, 4.5f, 12.9997f, 4.16421f, 12.9997f, 3.75f)
                close()
            }
        }.build()
    }

    val SaveTo: ImageVector by lazy {
        ImageVector.Builder(
            name = "save-arrow-right",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(3f, 5.75f)
                curveTo(3f, 4.23122f, 4.23122f, 3f, 5.75f, 3f)
                horizontalLineTo(15.7145f)
                curveTo(16.5764f, 3f, 17.4031f, 3.34241f, 18.0126f, 3.9519f)
                lineTo(20.0481f, 5.98744f)
                curveTo(20.6576f, 6.59693f, 21f, 7.42358f, 21f, 8.28553f)
                verticalLineTo(12.0218f)
                curveTo(20.5368f, 11.7253f, 20.0335f, 11.4858f, 19.5f, 11.3135f)
                verticalLineTo(8.28553f)
                curveTo(19.5f, 7.8214f, 19.3156f, 7.37629f, 18.9874f, 7.0481f)
                lineTo(16.9519f, 5.01256f)
                curveTo(16.6918f, 4.75246f, 16.3582f, 4.58269f, 16f, 4.52344f)
                verticalLineTo(7.25f)
                curveTo(16f, 8.49264f, 14.9926f, 9.5f, 13.75f, 9.5f)
                horizontalLineTo(9.25f)
                curveTo(8.00736f, 9.5f, 7f, 8.49264f, 7f, 7.25f)
                verticalLineTo(4.5f)
                horizontalLineTo(5.75f)
                curveTo(5.05964f, 4.5f, 4.5f, 5.05964f, 4.5f, 5.75f)
                verticalLineTo(18.25f)
                curveTo(4.5f, 18.9404f, 5.05964f, 19.5f, 5.75f, 19.5f)
                horizontalLineTo(6f)
                verticalLineTo(14.25f)
                curveTo(6f, 13.0074f, 7.00736f, 12f, 8.25f, 12f)
                horizontalLineTo(14.0343f)
                curveTo(13.3987f, 12.4013f, 12.8376f, 12.9098f, 12.3762f, 13.5f)
                horizontalLineTo(8.25f)
                curveTo(7.83579f, 13.5f, 7.5f, 13.8358f, 7.5f, 14.25f)
                verticalLineTo(19.5f)
                horizontalLineTo(11.3135f)
                curveTo(11.4858f, 20.0335f, 11.7253f, 20.5368f, 12.0218f, 21f)
                horizontalLineTo(5.75f)
                curveTo(4.23122f, 21f, 3f, 19.7688f, 3f, 18.25f)
                verticalLineTo(5.75f)
                close()
                moveTo(8.5f, 4.5f)
                verticalLineTo(7.25f)
                curveTo(8.5f, 7.66421f, 8.83579f, 8f, 9.25f, 8f)
                horizontalLineTo(13.75f)
                curveTo(14.1642f, 8f, 14.5f, 7.66421f, 14.5f, 7.25f)
                verticalLineTo(4.5f)
                horizontalLineTo(8.5f)
                close()
                moveTo(23f, 17.5f)
                curveTo(23f, 20.5376f, 20.5376f, 23f, 17.5f, 23f)
                curveTo(14.4624f, 23f, 12f, 20.5376f, 12f, 17.5f)
                curveTo(12f, 14.4624f, 14.4624f, 12f, 17.5f, 12f)
                curveTo(20.5376f, 12f, 23f, 14.4624f, 23f, 17.5f)
                close()
                moveTo(14.5f, 17f)
                curveTo(14.2239f, 17f, 14f, 17.2239f, 14f, 17.5f)
                curveTo(14f, 17.7761f, 14.2239f, 18f, 14.5f, 18f)
                horizontalLineTo(19.2929f)
                lineTo(17.6464f, 19.6464f)
                curveTo(17.4512f, 19.8417f, 17.4512f, 20.1583f, 17.6464f, 20.3536f)
                curveTo(17.8417f, 20.5488f, 18.1583f, 20.5488f, 18.3536f, 20.3536f)
                lineTo(20.8536f, 17.8536f)
                curveTo(21.0488f, 17.6583f, 21.0488f, 17.3417f, 20.8536f, 17.1464f)
                lineTo(18.3536f, 14.6464f)
                curveTo(18.1583f, 14.4512f, 17.8417f, 14.4512f, 17.6464f, 14.6464f)
                curveTo(17.4512f, 14.8417f, 17.4512f, 15.1583f, 17.6464f, 15.3536f)
                lineTo(19.2929f, 17f)
                horizontalLineTo(14.5f)
                close()
            }
        }.build()
    }

    val ShareUrl: ImageVector by lazy {
        ImageVector.Builder(
            name = "share",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(10.2499f, 2.99985f)
                curveTo(10.6641f, 2.99985f, 10.9999f, 3.33571f, 10.9999f, 3.74985f)
                curveTo(10.9999f, 4.16407f, 10.6642f, 4.49985f, 10.2499f, 4.49985f)
                horizontalLineTo(6.74994f)
                curveTo(5.50735f, 4.49985f, 4.50002f, 5.50728f, 4.49994f, 6.74985f)
                verticalLineTo(17.2499f)
                lineTo(4.51166f, 17.4803f)
                curveTo(4.62708f, 18.6147f, 5.58511f, 19.4999f, 6.74994f, 19.4999f)
                horizontalLineTo(17.2499f)
                curveTo(18.4926f, 19.4999f, 19.4999f, 18.4925f, 19.4999f, 17.2499f)
                verticalLineTo(15.2499f)
                curveTo(19.5f, 14.8357f, 19.8358f, 14.4999f, 20.2499f, 14.4999f)
                curveTo(20.6641f, 14.4999f, 20.9999f, 14.8357f, 20.9999f, 15.2499f)
                verticalLineTo(17.2499f)
                curveTo(20.9999f, 19.3209f, 19.321f, 20.9999f, 17.2499f, 20.9999f)
                horizontalLineTo(6.74994f)
                curveTo(4.74372f, 20.9999f, 3.10545f, 19.4244f, 3.00482f, 17.4432f)
                lineTo(2.99994f, 17.2499f)
                verticalLineTo(6.74985f)
                curveTo(3.00002f, 4.67885f, 4.67892f, 2.99985f, 6.74994f, 2.99985f)
                horizontalLineTo(10.2499f)
                close()
                moveTo(14.9365f, 2.06821f)
                curveTo(15.2025f, 1.94588f, 15.5159f, 1.98997f, 15.7382f, 2.18052f)
                lineTo(22.7382f, 8.18052f)
                curveTo(22.8985f, 8.31798f, 22.9937f, 8.5173f, 22.9999f, 8.72837f)
                curveTo(23.006f, 8.93935f, 22.9224f, 9.14336f, 22.7704f, 9.28989f)
                lineTo(15.7704f, 16.0399f)
                curveTo(15.554f, 16.2486f, 15.2337f, 16.3077f, 14.957f, 16.1903f)
                curveTo(14.6801f, 16.0726f, 14.4999f, 15.8007f, 14.4999f, 15.4999f)
                verticalLineTo(12.5243f)
                curveTo(13.4856f, 12.5878f, 12.5295f, 12.7971f, 11.5605f, 13.2928f)
                curveTo(10.4241f, 13.8742f, 9.21636f, 14.8744f, 7.87103f, 16.5956f)
                lineTo(7.59955f, 16.9501f)
                curveTo(7.40582f, 17.2081f, 7.06877f, 17.3138f, 6.76263f, 17.2118f)
                curveTo(6.4564f, 17.1097f, 6.24994f, 16.8227f, 6.24994f, 16.4999f)
                curveTo(6.24996f, 13.6426f, 6.93653f, 10.9108f, 8.41791f, 8.87192f)
                curveTo(9.79374f, 6.97863f, 11.8288f, 5.72528f, 14.4999f, 5.52817f)
                verticalLineTo(2.74985f)
                lineTo(14.5078f, 2.64146f)
                curveTo(14.5441f, 2.39271f, 14.7037f, 2.17528f, 14.9365f, 2.06821f)
                close()
                moveTo(15.9999f, 6.24985f)
                curveTo(15.9999f, 6.66407f, 15.6642f, 6.99985f, 15.2499f, 6.99985f)
                curveTo(12.6932f, 6.99985f, 10.8549f, 8.06982f, 9.63177f, 9.75278f)
                curveTo(8.75381f, 10.961f, 8.17788f, 12.5099f, 7.91498f, 14.2459f)
                curveTo(8.91528f, 13.1985f, 9.89191f, 12.4608f, 10.8769f, 11.9569f)
                curveTo(12.3601f, 11.1981f, 13.8009f, 10.9999f, 15.2499f, 10.9999f)
                curveTo(15.4488f, 10.9999f, 15.6396f, 11.079f, 15.7802f, 11.2196f)
                curveTo(15.9208f, 11.3602f, 15.9999f, 11.551f, 15.9999f, 11.7499f)
                verticalLineTo(13.7342f)
                lineTo(21.1347f, 8.78208f)
                lineTo(15.9999f, 4.37974f)
                verticalLineTo(6.24985f)
                close()
            }
        }.build()
    }

    val ExportImage: ImageVector by lazy {
        ImageVector.Builder(
            name = "arrow-export",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(2.7525f, 4.5f)
                curveTo(3.1322f, 4.5f, 3.44594f, 4.78227f, 3.49554f, 5.14836f)
                lineTo(3.50237f, 5.25014f)
                lineTo(3.5f, 18.2542f)
                curveTo(3.49992f, 18.6684f, 3.16408f, 19.0041f, 2.74986f, 19.0041f)
                curveTo(2.37017f, 19.0041f, 2.05642f, 18.7218f, 2.00683f, 18.3557f)
                lineTo(2f, 18.2539f)
                lineTo(2.00237f, 5.24986f)
                curveTo(2.00244f, 4.83565f, 2.33829f, 4.5f, 2.7525f, 4.5f)
                close()
                moveTo(15.6471f, 6.30373f)
                lineTo(15.7197f, 6.21961f)
                curveTo(15.986f, 5.95338f, 16.4027f, 5.92921f, 16.6963f, 6.1471f)
                lineTo(16.7804f, 6.21972f)
                lineTo(21.777f, 11.2174f)
                curveTo(22.0431f, 11.4835f, 22.0674f, 11.8999f, 21.8498f, 12.1935f)
                lineTo(21.7773f, 12.2776f)
                lineTo(16.7807f, 17.2811f)
                curveTo(16.488f, 17.5742f, 16.0131f, 17.5745f, 15.72f, 17.2818f)
                curveTo(15.4536f, 17.0157f, 15.4291f, 16.5991f, 15.6467f, 16.3053f)
                lineTo(15.7193f, 16.2211f)
                lineTo(19.43f, 12.504f)
                lineTo(5.75295f, 12.5049f)
                curveTo(5.37326f, 12.5049f, 5.05946f, 12.2228f, 5.0098f, 11.8567f)
                lineTo(5.00295f, 11.7549f)
                curveTo(5.00295f, 11.3752f, 5.28511f, 11.0615f, 5.65118f, 11.0118f)
                lineTo(5.75295f, 11.0049f)
                lineTo(19.443f, 11.004f)
                lineTo(15.7196f, 7.28028f)
                curveTo(15.4534f, 7.01398f, 15.4292f, 6.59732f, 15.6471f, 6.30373f)
                lineTo(15.7197f, 6.21961f)
                lineTo(15.6471f, 6.30373f)
                close()
            }
        }.build()
    }

    val Help: ImageVector by lazy {
        ImageVector.Builder(
            name = "chat-help",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(12f, 2f)
                curveTo(17.5228f, 2f, 22f, 6.47715f, 22f, 12f)
                curveTo(22f, 17.5228f, 17.5228f, 22f, 12f, 22f)
                curveTo(10.3817f, 22f, 8.81782f, 21.6146f, 7.41286f, 20.888f)
                lineTo(3.58704f, 21.9553f)
                curveTo(2.92212f, 22.141f, 2.23258f, 21.7525f, 2.04691f, 21.0876f)
                curveTo(1.98546f, 20.8676f, 1.98549f, 20.6349f, 2.04695f, 20.4151f)
                lineTo(3.11461f, 16.5922f)
                curveTo(2.38637f, 15.186f, 2f, 13.6203f, 2f, 12f)
                curveTo(2f, 6.47715f, 6.47715f, 2f, 12f, 2f)
                close()
                moveTo(12f, 3.5f)
                curveTo(7.30558f, 3.5f, 3.5f, 7.30558f, 3.5f, 12f)
                curveTo(3.5f, 13.4696f, 3.87277f, 14.8834f, 4.57303f, 16.1375f)
                lineTo(4.72368f, 16.4072f)
                lineTo(3.61096f, 20.3914f)
                lineTo(7.59755f, 19.2792f)
                lineTo(7.86709f, 19.4295f)
                curveTo(9.12006f, 20.1281f, 10.5322f, 20.5f, 12f, 20.5f)
                curveTo(16.6944f, 20.5f, 20.5f, 16.6944f, 20.5f, 12f)
                curveTo(20.5f, 7.30558f, 16.6944f, 3.5f, 12f, 3.5f)
                close()
                moveTo(12f, 15.5f)
                curveTo(12.5523f, 15.5f, 13f, 15.9477f, 13f, 16.5f)
                curveTo(13f, 17.0523f, 12.5523f, 17.5f, 12f, 17.5f)
                curveTo(11.4477f, 17.5f, 11f, 17.0523f, 11f, 16.5f)
                curveTo(11f, 15.9477f, 11.4477f, 15.5f, 12f, 15.5f)
                close()
                moveTo(12f, 6.75f)
                curveTo(13.5188f, 6.75f, 14.75f, 7.98122f, 14.75f, 9.5f)
                curveTo(14.75f, 10.5108f, 14.4525f, 11.074f, 13.6989f, 11.8586f)
                lineTo(13.5303f, 12.0303f)
                curveTo(12.9084f, 12.6522f, 12.75f, 12.9163f, 12.75f, 13.5f)
                curveTo(12.75f, 13.9142f, 12.4142f, 14.25f, 12f, 14.25f)
                curveTo(11.5858f, 14.25f, 11.25f, 13.9142f, 11.25f, 13.5f)
                curveTo(11.25f, 12.4892f, 11.5475f, 11.926f, 12.3011f, 11.1414f)
                lineTo(12.4697f, 10.9697f)
                curveTo(13.0916f, 10.3478f, 13.25f, 10.0837f, 13.25f, 9.5f)
                curveTo(13.25f, 8.80964f, 12.6904f, 8.25f, 12f, 8.25f)
                curveTo(11.3528f, 8.25f, 10.8205f, 8.74187f, 10.7565f, 9.37219f)
                lineTo(10.75f, 9.5f)
                curveTo(10.75f, 9.91421f, 10.4142f, 10.25f, 10f, 10.25f)
                curveTo(9.58579f, 10.25f, 9.25f, 9.91421f, 9.25f, 9.5f)
                curveTo(9.25f, 7.98122f, 10.4812f, 6.75f, 12f, 6.75f)
                close()
            }
        }.build()
    }

    val Reset: ImageVector by lazy {
        ImageVector.Builder(
            name = "arrow-reset",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(6.78033f, 2.71967f)
                curveTo(7.07322f, 3.01256f, 7.07322f, 3.48744f, 6.78033f, 3.78033f)
                lineTo(4.56066f, 6f)
                horizontalLineTo(13.25f)
                curveTo(17.5302f, 6f, 21f, 9.46979f, 21f, 13.75f)
                curveTo(21f, 18.0302f, 17.5302f, 21.5f, 13.25f, 21.5f)
                curveTo(8.96979f, 21.5f, 5.5f, 18.0302f, 5.5f, 13.75f)
                curveTo(5.5f, 13.3358f, 5.83579f, 13f, 6.25f, 13f)
                curveTo(6.66421f, 13f, 7f, 13.3358f, 7f, 13.75f)
                curveTo(7f, 17.2018f, 9.79822f, 20f, 13.25f, 20f)
                curveTo(16.7018f, 20f, 19.5f, 17.2018f, 19.5f, 13.75f)
                curveTo(19.5f, 10.2982f, 16.7018f, 7.5f, 13.25f, 7.5f)
                horizontalLineTo(4.56066f)
                lineTo(6.78033f, 9.71967f)
                curveTo(7.07322f, 10.0126f, 7.07322f, 10.4874f, 6.78033f, 10.7803f)
                curveTo(6.48744f, 11.0732f, 6.01256f, 11.0732f, 5.71967f, 10.7803f)
                lineTo(2.21967f, 7.28033f)
                curveTo(1.92678f, 6.98744f, 1.92678f, 6.51256f, 2.21967f, 6.21967f)
                lineTo(5.71967f, 2.71967f)
                curveTo(6.01256f, 2.42678f, 6.48744f, 2.42678f, 6.78033f, 2.71967f)
                close()
            }
        }.build()
    }

    val Theme: ImageVector by lazy {
        ImageVector.Builder(
            name = "dark-theme",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(12f, 22f)
                curveTo(17.5228f, 22f, 22f, 17.5228f, 22f, 12f)
                curveTo(22f, 6.47715f, 17.5228f, 2f, 12f, 2f)
                curveTo(6.47715f, 2f, 2f, 6.47715f, 2f, 12f)
                curveTo(2f, 17.5228f, 6.47715f, 22f, 12f, 22f)
                close()
                moveTo(12f, 20.5f)
                verticalLineTo(3.5f)
                curveTo(16.6944f, 3.5f, 20.5f, 7.30558f, 20.5f, 12f)
                curveTo(20.5f, 16.6944f, 16.6944f, 20.5f, 12f, 20.5f)
                close()
            }
        }.build()
    }

    val MapStyle: ImageVector by lazy {
        ImageVector.Builder(
            name = "map",
            defaultWidth = 24.dp,
            defaultHeight = 24.dp,
            viewportWidth = 24f,
            viewportHeight = 24f
        ).apply {
            path(
                fill = SolidColor(Color.Black)
            ) {
                moveTo(9.20337f, 3.9993f)
                lineTo(9.25042f, 3.99805f)
                lineTo(9.29617f, 3.99926f)
                curveTo(9.31861f, 4.00055f, 9.34109f, 4.00288f, 9.36355f, 4.00628f)
                lineTo(9.37963f, 4.01009f)
                curveTo(9.46504f, 4.02381f, 9.54992f, 4.05432f, 9.63082f, 4.10224f)
                lineTo(9.68268f, 4.13578f)
                lineTo(14.753f, 7.70105f)
                lineTo(19.82f, 4.13913f)
                curveTo(20.2878f, 3.81034f, 20.9215f, 4.10586f, 20.9944f, 4.6482f)
                lineTo(21.0014f, 4.75269f)
                verticalLineTo(15.3852f)
                curveTo(21.0014f, 15.5945f, 20.914f, 15.7926f, 20.7632f, 15.9334f)
                lineTo(20.6827f, 15.9988f)
                lineTo(15.1827f, 19.8652f)
                curveTo(14.9158f, 20.0528f, 14.5948f, 20.0371f, 14.3549f, 19.8883f)
                lineTo(9.25002f, 16.297f)
                lineTo(4.18035f, 19.8618f)
                curveTo(3.71263f, 20.1906f, 3.07889f, 19.8951f, 3.00595f, 19.3527f)
                lineTo(2.99902f, 19.2483f)
                verticalLineTo(8.61572f)
                curveTo(2.99902f, 8.4064f, 3.08638f, 8.20832f, 3.23714f, 8.06755f)
                lineTo(3.3177f, 8.00216f)
                lineTo(8.8177f, 4.13578f)
                curveTo(8.8817f, 4.09079f, 8.94882f, 4.05749f, 9.01717f, 4.03491f)
                lineTo(9.13964f, 4.0069f)
                lineTo(9.20337f, 3.9993f)
                close()
                moveTo(19.5014f, 6.1967f)
                lineTo(15.5014f, 9.00861f)
                verticalLineTo(17.8076f)
                lineTo(19.5014f, 14.9957f)
                verticalLineTo(6.1967f)
                close()
                moveTo(8.49902f, 6.19335f)
                lineTo(4.49902f, 9.00526f)
                verticalLineTo(17.8042f)
                lineTo(8.49902f, 14.9923f)
                verticalLineTo(6.19335f)
                close()
                moveTo(10.0014f, 6.19335f)
                verticalLineTo(14.9923f)
                lineTo(14.0014f, 17.8042f)
                verticalLineTo(9.00526f)
                lineTo(10.0014f, 6.19335f)
                close()
            }
        }.build()
    }
}

